import { render, staticRenderFns } from "./BDXWizardCoverholders.vue?vue&type=template&id=09ac5a2a"
import script from "./BDXWizardCoverholders.vue?vue&type=script&lang=js"
export * from "./BDXWizardCoverholders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports